import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Vehicle} from "domain-models"
import React from "react"
import {boolText, date, hasFlag, make, model, number, vehicleAttribute} from '../../../../../filters'
import Trans from '../../../../../components/Trans'

type CommonProps = {
  vehicle: Vehicle
}

class Common extends React.Component<CommonProps> {
  render() {
    const vehicle = this.props.vehicle
    return (
      <div className="w-full flex flex-row flex-wrap mt-10 md:mt-0 text-gray-700">
        <span className='font-semibold text-lg text-gray-700 w-full'>
          <Icon icon={['fas', 'info-circle']}/> <Trans>Allgemein</Trans>
        </span>

        <div className='flex flex-row flex-wrap w-full'>
          <span className='w-full truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Kurzbeschreibung</Trans></span>
            <span className="font-semibold text-gray-800">{vehicle.ShortDescription || '-'}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Marke</Trans></span>
            <span className="font-semibold text-gray-800">{make(vehicle.Make)}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Modell</Trans></span>
            <span className="font-semibold text-gray-800">{model(vehicle.Make, vehicle.Model)}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Kategorie</Trans></span>
            <span className="font-semibold text-gray-800">{vehicleAttribute('Category', vehicle.Category)}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Nutzungstyp</Trans></span>
            <span className="font-semibold text-gray-800">{vehicleAttribute('Type', vehicle.Type)}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Nutzfahrzeug</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{boolText(hasFlag(vehicle, 'SellFlags2', 32768))}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Aufbau</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('Body', vehicle.Body)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Kabinenart</Trans></span>
            <span className="font-semibold text-gray-800"><Trans>{vehicleAttribute('Cabin', vehicle.Cabin)}</Trans></span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw"><Trans>Kilometer</Trans></span>
            <span className="font-semibold text-gray-800">{number(vehicle.Kilometers, 0, 'km')}</span>
          </span>

          <span className='w-1/2 md:w-1/3 truncate flex flex-col mt-1'>
            <span className="text-gray-600 font-normal fa-fw">EZ</span>
            <span className="font-semibold text-gray-800">{date(vehicle.RegistrationDate)}</span>
          </span>
        </div>
      </div>
    )
  }
}

export default Common
